export default function addHeader(doc, logo, axionUrl, margins, offset) {
    doc.addImage(logo, "jpeg", 10, 2, 13, 13, undefined, "FAST");
    doc.link(10, 2, 13, 13, { url: axionUrl });
    doc.setFontSize(12);
    doc.textWithLink("Axion Biosystems", doc.internal.pageSize.width / 2 - 18, 8, { url: axionUrl });
    doc.line(margins.h, offset.v, doc.internal.pageSize.width - margins.h, offset.v);
}
